import React from 'react';
import {
  ButtonIcon,
  IconActionPanel,
} from '@spotify-internal/encore-creator-web';
import { useViewport, Viewport } from '../../../shared/lib/useViewport';
import { useActionPanelState } from '../';

const actionPanelShowButtonRef = React.createRef<HTMLDivElement>();
/**
 * Returns a ref for rendering `<ActionPanelShowButton />` via
 * `React.createPortal()` without having to query for a DOM element.
 */
export const useActionPanelShowButtonRef = () => actionPanelShowButtonRef;

/**
 * This component is rendering the React Portal target DOM node for the actual
 * `<ActionPanelShowButton />`
 */
export function ActionPanelShowButtonRef() {
  return <div ref={actionPanelShowButtonRef} />;
}

export function ActionPanelShowButton(props: {}) {
  const viewport = useViewport();
  const isSmallScreen = viewport === Viewport.SM || viewport === Viewport.XS;
  const { showActionPanel } = useActionPanelState();

  if (!isSmallScreen) {
    return null;
  }

  return (
    <ButtonIcon onClick={() => showActionPanel()} {...props}>
      <IconActionPanel />
    </ButtonIcon>
  );
}
